var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 1.16797H8.16634C7.5475 1.16797 6.95401 1.4138 6.51643 1.85139C6.07884 2.28897 5.83301 2.88246 5.83301 3.5013V24.5013C5.83301 25.1201 6.07884 25.7136 6.51643 26.1512C6.95401 26.5888 7.5475 26.8346 8.16634 26.8346H19.833C20.4518 26.8346 21.0453 26.5888 21.4829 26.1512C21.9205 25.7136 22.1663 25.1201 22.1663 24.5013V3.5013C22.1663 2.88246 21.9205 2.28897 21.4829 1.85139C21.0453 1.4138 20.4518 1.16797 19.833 1.16797ZM19.833 22.168H8.16634V5.83464H19.833V22.168ZM18.6663 15.168H15.1663V9.33463H12.833V15.168H9.33301L13.9997 19.8346L18.6663 15.168Z",
    fill: "#F83758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileActive);
export default __webpack_public_path__ + "static/media/mobileActive.3a404ee08024ef293cc84a8ada54da05.svg";
export { ForwardRef as ReactComponent };